


























import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import EVMTxSummary from '@/components/Transaction/EVMTxSummary.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { getEVMTransactionByHash } from '@/services/evmtransactions'
import { CURRENT_SUBNET, HAS_SUBNET } from '@/store/modules/network/network'

@Component({
    components: {
        Loader,
        EVMTxSummary,
        HTTPError,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMTransactionPage extends Mixins(
    TransactionsGettersMixin
) {
    to = ''
    from = ''
    blockchainTX: any = null
    async created() {
        if (CURRENT_SUBNET !== null) {
            await this.getTXID()
        } else {
            await this.getData()
        }
    }
    @Watch('txId')
    async ontxIdChanged() {
        await this.getData()
    }

    @Watch('assetsLoaded')
    async onAssetsLoaded() {
        await this.getData()
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get txId(): string {
        return this.$route.params.id
    }
    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }

    get tx() {
        const tx = this.getEVMTx()
        if (tx) {
            if (tx.fromAddr === '') tx.fromAddr = this.from
            if (tx.toAddr === '') tx.toAddr = this.to
            return tx
        } else {
            return null
        }
    }
    get loader() {
        return this.$store.state.Transactions.fetching
    }
    async getTXID() {
        const blockchainTx = await getEVMTransactionByHash({ hash: this.txId })
        this.blockchainTX = blockchainTx
        return
        // this.to = blockchainTx.to
        // this.from = blockchainTx.from
    }

    async getData() {
        if (this.assetsLoaded) {
            await this.$store.dispatch('Transactions/getEVMTx', {
                hash: this.txId,
            })
        }
        return
    }
}
